import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { Comment } from 'store/comments/interfaces/Comment';

export const getPDPComments = createAsyncThunk<Comment[], { threadId: number }>(
  'pdp/getPDPComments',
  async ({ threadId }, { rejectWithValue }) =>
    api.axios
      .get(`/api/comment/thread/${threadId}/comment`)
      .then((res) => res.data.list || res.data.data || res.data || [])
      .catch((e) => rejectWithValue(e.response?.data)),
);
